import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PLinkPure, PText } from '@porsche-design-system/components-react';

const Card = styled('div', {
  base: {
    backgroundColor: 'background.surface',
    padding: 'md',
    marginBottom: 'md',
    maxWidth: '380px',
  },
});

const Header = styled('div', {
  base: {
    paddingBottom: 'md',
  },
});

const Link = styled(PLinkPure, {
  base: {
    width: '100%',
  },
});

export const ContactCard = ({
  name,
  mail,
  role,
  phone,
}: {
  name: string;
  mail: string;
  role?: string;
  phone?: string;
}) => (
  <Card>
    <Header>
      <PText weight="bold" size="md">
        {name}
      </PText>
      {role && <PText>{role}</PText>}
    </Header>
    <Link href={`mailto:${mail}`} icon="email">
      {mail}
    </Link>
    {phone && (
      <Link href={`tel:${phone}`} icon="phone">
        {phone}
      </Link>
    )}
  </Card>
);
